export const STATUS = {
  pending_approval: ["Waiting for approval", "bg-amber-50 text-amber-700 border-amber-200"],
  queued: ["Queued", "bg-sky-50 text-sky-700 border-sky-200"],
  processing: ["Sending…", "bg-sky-50 text-sky-700 border-sky-200"],
  sent: ["Sent", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  delivered: ["Delivered", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  failed: ["Failed", "bg-red-50 text-red-700 border-red-200"],
  uncertain: ["Uncertain", "bg-orange-50 text-orange-700 border-orange-200"],
  skipped: ["Skipped", "bg-slate-50 text-slate-600 border-slate-200"],
  cancelled: ["Cancelled", "bg-slate-50 text-slate-500 border-slate-200"],
};

export const StatusBadge = ({ s, testid }) => {
  const [label, cls] = STATUS[s] || [s, "bg-slate-50 text-slate-600 border-slate-200"];
  return <span data-testid={testid} className={`inline-flex rounded-full border px-2 py-0.5 text-[11px] font-semibold ${cls}`}>{label}</span>;
};

export const CHANNEL = { sms: "Text", email: "Email" };

export const mdLabel = (md) => {
  if (!md) return "—";
  const [m, d] = md.split("-").map(Number);
  return new Date(2000, m - 1, d).toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

const GSM = "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";
export const smsSegments = (text) => {
  const chars = [...text];
  const unicode = chars.some((c) => !GSM.includes(c));
  const len = chars.length;
  const segs = unicode ? (len <= 70 ? 1 : Math.ceil(len / 67)) : (len <= 160 ? 1 : Math.ceil(len / 153));
  return { len, unicode, segs };
};
